import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { License } from 'app/Model/User/License';
import { LicenseSelectEntry } from 'app/Model/User/LicenseSelectEntry';

@Injectable()
export class LicenseService {
  constructor(private http: HttpClient,

  ) {
  }

  public getLicenseList(): Observable<Array<License>> {
    return (this.http.get<Array<License>>('api/License/GetLicenseList'));
  }

  public getSingleLicense(licenseId: string): Observable<License> {
    const options = {
      headers: new HttpHeaders().append('Content-Type', 'application/json'),
      params: new HttpParams().append('licenseId', licenseId)
    };

    return (this.http.get<License>('api/License/GetSingleLicense', options));
  }

  public createLicense(license: License): Observable<License> {
    const options = {
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    };

    return (this.http.post<License>('api/License/CreateLicense', license, options));
  }

  public updateLicense(license: License): Observable<License> {
    const options = {
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    };

    return (this.http.post<License>('api/License/UpdateLicense', license, options));
  }

  public deleteLicense(licenseId: string): Observable<void> {
    const options = {
      headers: new HttpHeaders().append('Content-Type', 'application/json'),
      params: new HttpParams().append('licenseId', licenseId)
    };

    return (this.http.delete('api/License/DeleteLicense', options)) as any;
  }

  public getLicenseSelectList(): Observable<Array<LicenseSelectEntry>> {

    return (this.http.get<Array<LicenseSelectEntry>>('api/License/GetLicenseSelectList'));
  }

  public getLicenseSelectSingleById(licenseId: string): Observable<LicenseSelectEntry> {

    const options = {
      params: new HttpParams().append('licenseId', licenseId)
    };

    return (this.http.get<LicenseSelectEntry>('api/License/GetLicenseSelectSingleById', options));
  }

  public getLicenseForCustomer(customerId: string): Observable<License> {
    const options = {
      headers: new HttpHeaders().append('Content-Type', 'application/json'),
      params: new HttpParams().append('customerId', customerId)
    };

    return (this.http.get<License>('api/License/GetLicenseOfCustomer', options));
  }
}
